//公共
import pc from 'VIEWS/router.js';

let routes = [];
let myRoutes = routes.concat(
    pc,
);
export default myRoutes;
